<template>
    <transition name="fade">
      <div v-if="isVisible" id="warn_popup" @click="closePopup">
        <div class="warn_popup" @click.stop>
          <div class="warn_popup1">
            <div>提示</div>
            <img src="../assets/image/icon_close.png" alt="" @click="closePopup">
          </div>
          <div class="warn_popup2">修改大纲后可能会出现与上文内容不符 请确认是否修改大纲?</div>
          <div class="warn_popup3">
            <div class="warn_popup4" @click="closePopup">确定</div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isVisible: false
      };
    },
    methods: {
      closePopup() {
        this.isVisible = false;
      },
      openPopup(){
        this.isVisible = true;
      }
    }
  };
  </script>
  
  <style>
  #warn_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .warn_popup {
    padding: 15px 30px;
    background: #FFFFFF;
    border-radius: 8px;
  }
  
  .warn_popup1 {
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 16px;
    color: #18191A;
  }
  
  .warn_popup1 img {
    width: 21px;
    cursor: pointer;
  }
  
  .warn_popup2 {
    width: 250px;
    font-size: 15px;
    color: #000000;
    margin: 15px 0;
  }
  
  .warn_popup3 {
    display: flex;
    justify-content: end;
  }
  
  .warn_popup4 {
    width: 83px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background-color: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
  }
  
  /* 淡入淡出动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
      